export const DepartmentModelConstants = {
  AL: {
    ID: 1n,
    DESCRIPTION: 'Alagoas',
    UF: 'AL',
  },
  AM: {
    ID: 2n,
    DESCRIPTION: 'Amazonas',
    UF: 'AM',
  },
  AP: {
    ID: 3n,
    DESCRIPTION: 'Amapá',
    UF: 'AP',
  },
  BA: {
    ID: 4n,
    DESCRIPTION: 'Bahia',
    UF: 'BA',
  },
  CE: {
    ID: 5n,
    DESCRIPTION: 'Ceará',
    UF: 'CE',
  },
  DF: {
    ID: 6n,
    DESCRIPTION: 'Distrito Federal',
    UF: 'DF',
  },
  ES: {
    ID: 7n,
    DESCRIPTION: 'Espírito Santo',
    UF: 'ES',
  },
  GO: {
    ID: 8n,
    DESCRIPTION: 'Goiás',
    UF: 'GO',
  },
  MA: {
    ID: 9n,
    DESCRIPTION: 'Maranhão',
    UF: 'MA',
  },
  MG: {
    ID: 10n,
    DESCRIPTION: 'Minas Gerais',
    UF: 'MG',
  },
  MS: {
    ID: 11n,
    DESCRIPTION: 'Mato Grosso do Sul',
    UF: 'MS',
  },
  MT: {
    ID: 12n,
    DESCRIPTION: 'Mato Grosso',
    UF: 'MT',
  },
  PA: {
    ID: 13n,
    DESCRIPTION: 'Pará',
    UF: 'PA',
  },
  PB: {
    ID: 14n,
    DESCRIPTION: 'Paraíba',
    UF: 'PB',
  },
  PE: {
    ID: 15n,
    DESCRIPTION: 'Pernambuco',
    UF: 'PE',
  },
  PI: {
    ID: 16n,
    DESCRIPTION: 'Piauí',
    UF: 'PI',
  },
  PR: {
    ID: 17n,
    DESCRIPTION: 'Paraná',
    UF: 'PR',
  },
  RJ: {
    ID: 18n,
    DESCRIPTION: 'Rio de Janeiro',
    UF: 'RJ',
  },
  RN: {
    ID: 19n,
    DESCRIPTION: 'Rio Grande do Norte',
    UF: 'RN',
  },
  RO: {
    ID: 20n,
    DESCRIPTION: 'Rondônia',
    UF: 'RO',
  },
  RR: {
    ID: 21n,
    DESCRIPTION: 'Roraima',
    UF: 'RR',
  },
  RS: {
    ID: 22n,
    DESCRIPTION: 'Rio Grande do Sul',
    UF: 'RS',
  },
  SC: {
    ID: 23n,
    DESCRIPTION: 'Santa Catarina',
    UF: 'SC',
  },
  SE: {
    ID: 24n,
    DESCRIPTION: 'Sergipe',
    UF: 'SE',
  },
  SP: {
    ID: 25n,
    DESCRIPTION: 'São Paulo',
    UF: 'SP',
  },
  TO: {
    ID: 26n,
    DESCRIPTION: 'Tocantins',
    UF: 'TO',
  },
  AC: {
    ID: 27n,
    DESCRIPTION: 'Acre',
    UF: 'AC',
  },
  CETIQT: {
    ID: 28n,
    DESCRIPTION: 'CETIQT',
    UF: 'DF',
  },
  DN: {
    ID: 29n,
    DESCRIPTION: 'Departamento Nacional',
    UF: 'DF',
  },
} as const

export type DepartmentID =
  (typeof DepartmentModelConstants)[keyof typeof DepartmentModelConstants]['ID']

export function getDepartmentDescriptionById(id: string): string | undefined {
  const departmentId = BigInt(id)

  return Object.values(DepartmentModelConstants)
    .find(dept => dept.ID === departmentId)
    ?.DESCRIPTION
}

export function getDepartmentUFById(id: string): string | undefined {
  const departmentId = BigInt(id)

  return Object.values(DepartmentModelConstants)
    .find(dept => dept.ID === departmentId)
    ?.UF
}
